import React from 'react';
import { QuestionTypeViewPropTypes } from '../../utils';
import { useNeuroMessages } from '../MessageContext';

const TextArea = (props) => {
  const {
    className,
    valueChanged,
    question,
    value: { value = {} } = {},
  } = props;

  const messageContext = useNeuroMessages();
  const attributes = question?.attributes || {};
  const currentValue = value instanceof Array && value.length > 0 ? value[0] : '';
  const placeholder = messageContext.getMessage(
    `${question.appkey}.textarea.placeholder`
  );
  const charLimit = messageContext.getMessage(
     `${question.appkey}.textarea.charactersRemaining`
  );
  
  const onChange = event => { 
    valueChanged(event.target.value); 
  };

  const rows = attributes.rows || 10;
  const maxLength = attributes.maxLength || 500;

  const renderFooter = () => {
    const numCharsRemaining = maxLength - currentValue.length;
    return (<div className="textArea__footer">
      { numCharsRemaining <= 10 && (<span>{`${numCharsRemaining} ${charLimit}`}</span>)}
    </div>);
  }; 

  return (
    <div className={className}>
      <div className="textArea__container">
        <textarea 
          id={`textArea__${question.appkey}`}
          rows={rows}
          maxLength={maxLength}
          onChange={onChange}
          placeholder={placeholder}
          autoFocus={attributes.autoFocus}
        >
          {currentValue}
        </textarea>
      </div>
      { attributes.showCharLimit ? renderFooter() : <></> }
    </div>
  );
};
TextArea.propTypes = QuestionTypeViewPropTypes;

export default TextArea;
